"use strict";

export default class UsersCreate {
  constructor($usersCreate) {
    this.$usersCreate = $usersCreate;

    this.form = new Object();
    this.form.$el = this.$usersCreate.querySelector('form');

    // NOTE: We are not using the permissions section/module at the moment.
    // this.form.$modulesMultipleSelect = this.form.$el.querySelector('#module-select-multiple');
    // this.form.$usersPermissionsSection = this.form.$el.querySelector('section#users-permissions');

    if (this.form.$usersPermissionsSection && !Boolean(this.$usersCreate.getAttribute('feedback-response'))) {
      this.form.$usersPermissionsSection.style.display = 'none';
    }

    this.permissionLabels = {
      "C": "create",
      "R": "read",
      "U": "update",
      "D": "delete"
    };

    this.permissionIndicators = {
      "C": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Créer" : "Create",
      "R": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Lire" : "Read",
      "U": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Éditer" : "Update",
      "D": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Supprimer" : "Delete"
    };

    this.bindEvents();
  }

  bindEvents() {
    // NOTE: We are not using the permissions section/module at the moment.
    // this.togglePermissionsSection();
  }

  togglePermissionsSection() {
    this.form.$modulesMultipleSelect.addEventListener('change', () => {
      const selectedOptions = new Array();
      const unselectedOptions = new Set();

      Array.from(this.form.$modulesMultipleSelect.options)
        .filter(option => option.selected)
        .forEach(option => {
          selectedOptions.push({
            [option.value]: option.text
          });
        });

      Array.from(this.form.$modulesMultipleSelect.options)
        .filter(option => !option.selected)
        .forEach(option => unselectedOptions.add(option.value));

      const permissionsTableBody = this.form.$usersPermissionsSection.querySelector('table tbody');

      if (selectedOptions.length <= 0) {
        permissionsTableBody.innerHTML = '';
        this.form.$usersPermissionsSection.style.display = 'none';

        return;
      }

      this.form.$usersPermissionsSection.style.display = 'block';

      selectedOptions.forEach(option => {
        const id = Object.keys(option)[0];
        const name = Object.values(option)[0];

        const $existingRow = permissionsTableBody.querySelector(`tr[id="${id}"]`);

        if ($existingRow) {
          return;
        }

        const $row = document.createElement('tr');
        $row.id = id;

        const $moduleNameCell = document.createElement('td');
        $moduleNameCell.textContent = name;
        $row.appendChild($moduleNameCell);

        for (const shortLabel of Object.keys(this.permissionLabels)) {
          const $permissionCell = document.createElement('td');

          const $permissionLabel = document.createElement("label");
          $permissionLabel.setAttribute("for", `${this.permissionLabels[shortLabel]}-module-${id}`);
          $permissionLabel.textContent = this.permissionIndicators[shortLabel];

          const $permissionInput = document.createElement("input");
          $permissionInput.setAttribute("type", "checkbox");
          $permissionInput.setAttribute("name", `permissions[${id}][${shortLabel.toUpperCase()}]`);
          $permissionInput.setAttribute("id", `${this.permissionLabels[shortLabel]}-module-${id}`);

          $permissionCell.appendChild($permissionLabel);
          $permissionCell.appendChild($permissionInput);
          $row.appendChild($permissionCell);
        }

        permissionsTableBody.appendChild($row);
      });

      unselectedOptions.forEach(moduleId => {
        const $existingRow = permissionsTableBody.querySelector(`tr[id="${moduleId}"]`);

        if ($existingRow) {
          $existingRow.remove();
        }
      });
    });
  }
}
